import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar la soledad",
    opening: localizedGenderNode(
      [
      "Hoy no intento llenarla.",
      "Solo noto la soledad cuando está aquí.",
      "Eso es suficiente por ahora."
    ],
      [
      "Hoy no intento llenarla.",
      "Solo noto la soledad cuando está aquí.",
      "Eso es suficiente por ahora."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo se siente más la soledad?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente la soledad en mi cuerpo?"
    ],
      [
      "¿Cuándo se siente más la soledad?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente la soledad en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar la soledad ya es una conexión suave."
    ],
      [
      "Notar la soledad ya es una conexión suave."
    ]
    ),
    action: localizedGenderNode(
      "una respiración con las palabras \"Estoy aquí\".",
      "una respiración con las palabras \"Estoy aquí\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Qué me falta allí",
    opening: localizedGenderNode(
      [
      "Hoy pregunto qué me falta dentro de la gente alrededor.",
      "Sin culpa.",
      "Solo ver."
    ],
      [
      "Hoy pregunto qué me falta dentro de la gente alrededor.",
      "Sin culpa.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el pecho."
    ],
      [
      "Respiro despacio.",
      "Siento el pecho."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me falta en mi conexión con la gente a mi alrededor?",
      "¿Qué me gustaría que vieran en mí?",
      "¿Qué me cuesta pedir?"
    ],
      [
      "¿Qué me falta en mi conexión con la gente a mi alrededor?",
      "¿Qué me gustaría que vieran en mí?",
      "¿Qué me cuesta pedir?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A veces una falta pequeña explica mucho."
    ],
      [
      "A veces una falta pequeña explica mucho."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre lo que falta.",
      "escribir una palabra sobre lo que falta."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "El momento en que me alejo",
    opening: localizedGenderNode(
      [
      "Hoy noto el momento en que me alejo.",
      "Sin juzgar.",
      "Solo ver."
    ],
      [
      "Hoy noto el momento en que me alejo.",
      "Sin juzgar.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo me cierro cerca de la gente?",
      "¿Qué lo activa en mí?",
      "¿Qué intento proteger?"
    ],
      [
      "¿Cuándo me cierro cerca de la gente?",
      "¿Qué lo activa en mí?",
      "¿Qué intento proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Incluso cerrarme es un intento de proteger."
    ],
      [
      "Incluso cerrarme es un intento de proteger."
    ]
    ),
    action: localizedGenderNode(
      "decirme \"Lo entiendo\".",
      "decirme \"Lo entiendo\"."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Presencia sin máscara",
    opening: localizedGenderNode(
      [
      "Hoy observo cómo es estar un momento sin máscara.",
      "No mucho.",
      "Solo un poco."
    ],
      [
      "Hoy observo cómo es estar un momento sin máscara.",
      "No mucho.",
      "Solo un poco."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el rostro."
    ],
      [
      "Respiro despacio.",
      "Siento el rostro."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué suelo ocultar?",
      "¿Qué temo que vean?",
      "¿Dónde puedo soltar un 1%?"
    ],
      [
      "¿Qué suelo ocultar?",
      "¿Qué temo que vean?",
      "¿Dónde puedo soltar un 1%?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un momento pequeño de verdad calienta el corazón."
    ],
      [
      "Un momento pequeño de verdad calienta el corazón."
    ]
    ),
    action: localizedGenderNode(
      "una frase verdadera para mí.",
      "una frase verdadera para mí."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El patrón que me deja solo/a",
    opening: localizedGenderNode(
      [
      "Hoy veo un patrón pequeño que me aleja.",
      "Sin culpa.",
      "Solo luz."
    ],
      [
      "Hoy veo un patrón pequeño que me aleja.",
      "Sin culpa.",
      "Solo luz."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Siento el abdomen."
    ],
      [
      "Me detengo un momento.",
      "Siento el abdomen."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué patrón se repite cuando estoy con gente?",
      "¿Cómo me protege?",
      "¿Cuál es su costo para mí?"
    ],
      [
      "¿Qué patrón se repite cuando estoy con gente?",
      "¿Cómo me protege?",
      "¿Cuál es su costo para mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un patrón protector también puede doler."
    ],
      [
      "Un patrón protector también puede doler."
    ]
    ),
    action: localizedGenderNode(
      "nombrar un patrón.",
      "nombrar un patrón."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "La necesidad debajo",
    opening: localizedGenderNode(
      [
      "Hoy busco la necesidad debajo de la soledad.",
      "No una solución.",
      "Solo una necesidad."
    ],
      [
      "Hoy busco la necesidad debajo de la soledad.",
      "No una solución.",
      "Solo una necesidad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesito de verdad aquí?",
      "¿Qué me gustaría recibir?",
      "¿Qué puedo darme ahora?"
    ],
      [
      "¿Qué necesito de verdad aquí?",
      "¿Qué me gustaría recibir?",
      "¿Qué puedo darme ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una necesidad clara suaviza el corazón."
    ],
      [
      "Una necesidad clara suaviza el corazón."
    ]
    ),
    action: localizedGenderNode(
      "escribir una necesidad en una palabra.",
      "escribir una necesidad en una palabra."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Un pequeño momento de conexión",
    opening: localizedGenderNode(
      [
      "Hoy busco un pequeño momento de conexión.",
      "No grande.",
      "Pequeño es suficiente."
    ],
      [
      "Hoy busco un pequeño momento de conexión.",
      "No grande.",
      "Pequeño es suficiente."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Siento mi respiración."
    ],
      [
      "Me detengo un momento.",
      "Siento mi respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo tuve una pequeña conexión recientemente?",
      "¿Qué me permitió sentirla?",
      "¿Qué paso pequeño podría invitar más?"
    ],
      [
      "¿Cuándo tuve una pequeña conexión recientemente?",
      "¿Qué me permitió sentirla?",
      "¿Qué paso pequeño podría invitar más?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Incluso una conexión pequeña cambia el día."
    ],
      [
      "Incluso una conexión pequeña cambia el día."
    ]
    ),
    action: localizedGenderNode(
      "recordar un momento así.",
      "recordar un momento así."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Un límite que protege la conexión",
    opening: localizedGenderNode(
      [
      "Hoy veo un límite que me protege con la gente.",
      "Sin alejarme.",
      "Solo proteger."
    ],
      [
      "Hoy veo un límite que me protege con la gente.",
      "Sin alejarme.",
      "Solo proteger."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento los hombros."
    ],
      [
      "Respiro despacio.",
      "Siento los hombros."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde doy demasiado en las relaciones?",
      "¿Qué límite pequeño podría ayudar?",
      "¿Cómo me lo digo a mí?"
    ],
      [
      "¿Dónde doy demasiado en las relaciones?",
      "¿Qué límite pequeño podría ayudar?",
      "¿Cómo me lo digo a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un límite pequeño cuida la presencia."
    ],
      [
      "Un límite pequeño cuida la presencia."
    ]
    ),
    action: localizedGenderNode(
      "una frase de límite para mí.",
      "una frase de límite para mí."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Quedarme un momento más",
    opening: localizedGenderNode(
      [
      "Hoy practico quedarme un momento más.",
      "No desaparecer tan rápido.",
      "Solo un momento."
    ],
      [
      "Hoy practico quedarme un momento más.",
      "No desaparecer tan rápido.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo me voy demasiado rápido?",
      "¿Qué me asusta si me quedo?",
      "¿Qué pasa si me quedo 10 segundos más?"
    ],
      [
      "¿Cuándo me voy demasiado rápido?",
      "¿Qué me asusta si me quedo?",
      "¿Qué pasa si me quedo 10 segundos más?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un momento más a veces es un cambio."
    ],
      [
      "Un momento más a veces es un cambio."
    ]
    ),
    action: localizedGenderNode(
      "pausar 10 segundos antes de desaparecer.",
      "pausar 10 segundos antes de desaparecer."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una petición clara",
    opening: localizedGenderNode(
      [
      "Hoy formulo una petición hacia mí.",
      "No para exigir.",
      "Solo reconocer."
    ],
      [
      "Hoy formulo una petición hacia mí.",
      "No para exigir.",
      "Solo reconocer."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es una petición que me gustaría traer?",
      "¿Cómo puedo decirla con suavidad?",
      "¿Qué paso pequeño puedo dar?"
    ],
      [
      "¿Cuál es una petición que me gustaría traer?",
      "¿Cómo puedo decirla con suavidad?",
      "¿Qué paso pequeño puedo dar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede abrir una puerta a la conexión."
    ],
      [
      "Una petición puede abrir una puerta a la conexión."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase.",
      "escribir la petición en una frase."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Una mirada que sostiene",
    opening: localizedGenderNode(
      [
      "Hoy busco una mirada que me sostenga.",
      "Incluso una mirada interna.",
      "Suficiente."
    ],
      [
      "Hoy busco una mirada que me sostenga.",
      "Incluso una mirada interna.",
      "Suficiente."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Siento los ojos."
    ],
      [
      "Me detengo un momento.",
      "Siento los ojos."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Quién o qué me da una sensación de ser visto/a?",
      "¿Cómo se siente cuando alguien de verdad me ve?",
      "¿Cómo puedo darme eso a mí?"
    ],
      [
      "¿Quién o qué me da una sensación de ser visto/a?",
      "¿Cómo se siente cuando alguien de verdad me ve?",
      "¿Cómo puedo darme eso a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una mirada suave puede abrir espacio."
    ],
      [
      "Una mirada suave puede abrir espacio."
    ]
    ),
    action: localizedGenderNode(
      "mirarme en el espejo con suavidad un momento.",
      "mirarme en el espejo con suavidad un momento."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Una voz tranquila dentro",
    opening: localizedGenderNode(
      [
      "Hoy escucho la voz tranquila dentro de mí.",
      "Aunque sea pequeña.",
      "Está allí."
    ],
      [
      "Hoy escucho la voz tranquila dentro de mí.",
      "Aunque sea pequeña.",
      "Está allí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Le doy espacio."
    ],
      [
      "Respiro despacio.",
      "Le doy espacio."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me dice ahora esa voz tranquila?",
      "¿Qué me pide?",
      "¿Cómo se siente escucharla?"
    ],
      [
      "¿Qué me dice ahora esa voz tranquila?",
      "¿Qué me pide?",
      "¿Cómo se siente escucharla?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz tranquila puede devolverme a mí."
    ],
      [
      "Una voz tranquila puede devolverme a mí."
    ]
    ),
    action: localizedGenderNode(
      "una frase de esa voz tranquila.",
      "una frase de esa voz tranquila."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Una elección pequeña hacia la conexión",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño hacia la conexión.",
      "Sin drama.",
      "Un paso pequeño."
    ],
      [
      "Hoy elijo un paso pequeño hacia la conexión.",
      "Sin drama.",
      "Un paso pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué me asusta de ese paso?",
      "¿Cómo me va a proteger?"
    ],
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué me asusta de ese paso?",
      "¿Cómo me va a proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un paso pequeño puede cambiar el ritmo."
    ],
      [
      "Un paso pequeño puede cambiar el ritmo."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño y recordarlo.",
      "elegir un paso pequeño y recordarlo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase que me devuelve a la conexión.",
      "Cuando me cierro.",
      "Una frase pequeña."
    ],
      [
      "Hoy elijo una frase que me devuelve a la conexión.",
      "Cuando me cierro.",
      "Una frase pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre esta soledad?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ],
      [
      "¿Qué aprendí sobre esta soledad?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo sentirme solo/a y aun así quedarme conmigo."
    ],
      [
      "Puedo sentirme solo/a y aun así quedarme conmigo."
    ]
    ),
    action: localizedGenderNode(
      "decir la nueva frase una vez.",
      "decir la nueva frase una vez."
    ),
  },
].map(buildNormalizedDay);

export const lonelinessEvenWhenThereArePeopleAroundBlueprintEs = buildNormalizedPilotBlueprint({
  id: "loneliness_even_when_there_are_people_around_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "loneliness_even_when_there_are_people_around",
  category: "loneliness_belonging",
  journeyName: {
    he: "בדידות גם כשיש אנשים מסביב",
    en: "Loneliness even when there are people around",
    es: "Soledad incluso cuando hay gente alrededor",
  },
  days,
});

export default lonelinessEvenWhenThereArePeopleAroundBlueprintEs;
